import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, WritableComputedRef } from 'vue';

interface Props {
  option?: any;
  disableSelect?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiSelectOption',
  props: {
    option: { default: () => ({}) },
    disableSelect: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { option: any, disableSelect: boolean };



const {
  valueLocal: selectValue,
  selectOption,
  itemId,
  itemText,
} = inject('selectData') as {
  valueLocal: WritableComputedRef<any>;
  selectOption: (option: any) => void;
  itemId: string;
  itemText: string;
};

const isActive = computed(() => props.option[itemId] === selectValue.value);

const handleSelectOption = (option: any) => {
  selectOption(option);
};

return { __sfc: true,props, selectValue, selectOption, itemId, itemText, isActive, handleSelectOption }
}

})